<script setup lang="ts">
const integrationStore = useStore('integration')
const platforms = integrationStore.description.properties.platform.enum

defineProps<{
  modelValue?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <div>
    <div class="text-xs">
      Selecionado: <b>{{ modelValue }}</b>
    </div>
    <div class="
      flex
      flex-wrap
      gap
      gap-2
    ">
      <aeria-info
        v-for="platform in platforms"
        :key="platform"
        >
        <template #text>
          {{ platform }}
        </template>
        <div
          v-clickable
          :class="`
            border
            rounded
            p-4
            ${platform === modelValue && 'border-blue-100 bg-blue-100'}
          `"
          @click="emit('update:modelValue', platform)"
        >
          <extra-icon
            :name="platform"
            size="1.8rem"
          />
        </div>
      </aeria-info>
    </div>
  </div>
</template>
